import { AssetResponseAssetType } from 'generatedTypes/asset/models';

import Toggle from 'components/Toggle';

import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { AssetOption, FunctionComponent, Props } from './types';

const AssetToggle: FunctionComponent<Props> = ({
    assetType,
    className = '',
    onChange,
    pluralize = false,
    testId = TEST_ID
}) => {
    const { BATTERY, DRONE } = useTranslation();

    const shouldPluralize = Number(pluralize) + 1;

    const options: AssetOption[] = [
        { label: DRONE({ count: shouldPluralize }), value: AssetResponseAssetType.DRONE },
        { label: BATTERY({ count: shouldPluralize }), value: AssetResponseAssetType.BATTERY }
    ];

    const activeIndex = options.findIndex(option => option.value === assetType);

    const handleClick = (value: string) => {
        const selectedOption = options.find(option => option.value === value);

        if (!selectedOption) {
            return;
        }

        onChange(selectedOption.value);
    };

    return (
        <Toggle
            activeIndex={activeIndex}
            className={className}
            onClick={handleClick}
            options={options}
            testId={testId}
        />
    );
};

export default AssetToggle;
